//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('workingOrders', {
//        templateUrl: 'views/components/views/workingOrders/workingOrders.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'workingOrdersService', function ($stateParams, workingOrdersService) {
            
//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let ok = $stateParams.ok;

//            vm.model = {
//                itemsListActivities: []
//            };

//		    // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadActivities() {
//                vm.model.itemsListActivities = await workingOrdersService.listCustacts({
//                    cust_name: 'ALL',
//                    cust_no: '0',
//                    project_keyno: '0',
//                    ok: ok
//                });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadActivities();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
